export default function AboutSection() {
  return (
    <section id="sobre" className="pt-24 pb-12 bg-[#f8f6f2]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div>
            <span className="text-[#c9a84c] text-sm font-bold tracking-widest uppercase">
              Quem Somos
            </span>
            <h2 className="font-serif text-3xl md:text-6xl font-bold text-[#0f2651] mt-3 mb-6 leading-tight">
              Não somos um escritório<br />
              <span className="text-[#c9a84c]">contábil tradicional.</span>
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-5">
              A RCP Inteligência Contábil &amp; Tributária nasce com um diferencial claro: unir
              experiência contábil, fiscal e visão de auditoria para entregar muito mais do que
              obrigações — entregamos{' '}
              <strong>controle, segurança e resultado</strong>.
            </p>
            <p className="text-gray-600 text-lg leading-relaxed mb-8">
              Somos formados por profissionais com sólida atuação em auditoria contábil e área
              fiscal, preparados para identificar riscos, corrigir falhas e estruturar empresas para
              crescer com consistência.
            </p>
            <div className="flex items-center gap-3 bg-[#0f2651]/5 border border-[#0f2651]/10 rounded-lg px-5 py-4">
              <div className="w-10 h-10 flex items-center justify-center text-[#c9a84c]">
                <i className="ri-shield-check-line text-2xl" />
              </div>
              <p className="text-[#0f2651] text-base font-medium">
                Atuamos como <strong>parceiros estratégicos</strong> do seu negócio, utilizando
                práticas de auditoria para garantir sua segurança fiscal.
              </p>
            </div>
          </div>

          <div className="relative">
            <div className="rounded-lg overflow-hidden">
              <img
                alt="Mesa de escritório contábil com laptop e planilhas financeiras"
                className="w-full h-[480px] object-cover object-top"
                src="https://public.readdy.ai/ai/img_res/edited_0263bfeda8d4983b47b0eb09cffc8aac_620e8f5b.jpg"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-[#0f2651] text-white rounded-lg px-6 py-5">
              <div className="text-3xl font-bold text-[#c9a84c]">100%</div>
              <div className="text-xs text-white/70 mt-1">
                Conformidade fiscal<br />garantida
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mt-20">
          {[
            {
              icon: 'ri-bar-chart-box-line',
              title: 'Inteligência Contábil',
              desc: 'Organização, análise e estruturação dos dados para gerar informações confiáveis e decisões seguras.',
            },
            {
              icon: 'ri-scales-3-line',
              title: 'Estratégia Tributária',
              desc: 'Planejamento para reduzir impostos dentro da legalidade, preservando o resultado da sua empresa.',
            },
            {
              icon: 'ri-search-eye-line',
              title: 'Visão de Auditoria',
              desc: 'Revisão crítica dos processos para identificar erros, riscos ocultos e oportunidades de melhoria.',
            },
          ].map((item) => (
            <div
              key={item.title}
              className="bg-white border border-gray-100 rounded-lg p-7 hover:border-[#c9a84c]/30 transition-colors duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#0f2651]/5 rounded-lg mb-4 text-[#0f2651]">
                <i className={`${item.icon} text-2xl`} />
              </div>
              <h3 className="text-xl font-bold text-[#0f2651] mb-2">{item.title}</h3>
              <p className="text-gray-500 text-base leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-20 grid md:grid-cols-2 gap-6">
          <div className="bg-[#0f2651] rounded-xl p-8">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center bg-[#c9a84c]/20 rounded-lg text-[#c9a84c]">
                <i className="ri-focus-3-line text-xl" />
              </div>
              <h3 className="font-serif text-xl font-bold text-white">Missão</h3>
            </div>
            <p className="text-white/65 text-base leading-relaxed">
              Entregar soluções contábeis e tributárias com visão estratégica, proporcionando
              informações confiáveis, transparência e segurança para apoiar a tomada de decisão e o
              crescimento sustentável das empresas.
            </p>
          </div>
          <div className="bg-[#f0ece4] rounded-xl p-8 border border-[#c9a84c]/20">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center bg-[#0f2651]/10 rounded-lg text-[#0f2651]">
                <i className="ri-eye-line text-xl" />
              </div>
              <h3 className="font-serif text-xl font-bold text-[#0f2651]">Visão</h3>
            </div>
            <p className="text-gray-600 text-base leading-relaxed">
              Ser reconhecida como uma empresa de referência em inteligência contábil e tributária,
              destacando-se pela qualidade técnica, atuação estratégica e capacidade de gerar valor
              real para os clientes.
            </p>
          </div>
        </div>

        <div className="mt-14">
          <div className="text-center mb-10">
            <span className="text-[#c9a84c] text-sm font-bold tracking-widest uppercase">
              O que nos guia
            </span>
            <h3 className="font-serif text-4xl font-bold text-[#0f2651] mt-2">Nossos Valores</h3>
          </div>
          <div className="bg-white border border-gray-100 rounded-xl px-8 py-10 flex flex-col gap-8">
            {[
              {
                icon: 'ri-shield-check-line',
                text: 'Atuamos com integridade, precisão e responsabilidade, entregando soluções contábeis e tributárias com alto padrão técnico e total confiabilidade.',
              },
              {
                icon: 'ri-compass-3-line',
                text: 'Aliamos conhecimento especializado a uma visão estratégica de negócio, contribuindo de forma consistente para decisões mais seguras e sustentáveis.',
              },
              {
                icon: 'ri-medal-line',
                text: 'Nossa atuação é pautada pela conformidade, excelência contínua e geração de valor real para cada cliente.',
              },
            ].map((v, i) => (
              <div key={i} className="flex items-start gap-5">
                <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-[#0f2651]/5 rounded-lg text-[#c9a84c] mt-0.5">
                  <i className={`${v.icon} text-xl`} />
                </div>
                <p className="text-gray-600 text-base leading-relaxed">{v.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
